import AppError from './AppError';

/**
 * Parses the pagination container. Subject is the supplied document
 */
export default class PaginationParser {
  constructor(
    private doc: Document | HTMLElement,
    private paginationWrapperSelector: string,
    private nextPageSelector: string
  ) {}

  /**
   * Does this document have a pagination element?
   */
  public hasPagination(): boolean {
    try {
      this.findPagination();
      return true;
    } catch {
      return false;
    }
  }

  /**
   * Gets the pagination container if it exists. Throws if not. use hasPagination to determine if it exists
   */
  public findPagination(): HTMLElement {
    const el = this.doc.querySelector<HTMLElement>(
      this.paginationWrapperSelector
    );
    if (!el || !(el instanceof HTMLElement)) {
      throw new AppError('unable to find pagination wrapper');
    }
    return el;
  }

  /**
   * Does this document have a next page element
   */
  public hasNextPage(): boolean {
    try {
      this.nextPageElement();
      return true;
    } catch {
      return false;
    }
  }

  /**
   * Get the next page element. This may throw if it doesn't exist. use hasNextPage to determine if it exists
   */
  public getNextPageUrl(): string {
    const el = this.nextPageElement();
    const url = el.href;
    return url;
  }

  private nextPageElement(): HTMLAnchorElement {
    const pagination = this.findPagination();
    const el = pagination.querySelector(this.nextPageSelector);
    if (!el || !(el instanceof HTMLAnchorElement)) {
      throw new AppError('unable to find next link');
    }
    return el;
  }
}
